import React from 'react';

/**
 * Church logo: open Bible with a dove (left page) and a flame (right page).
 * Uses the secondary gold color by default; pass `color` prop to override.
 */
export default function ChurchLogo({ size = 44, color = '#C9A84C' }) {
  return (
    <svg
      width={size}
      height={Math.round(size * 0.82)}
      viewBox="0 0 44 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* ── Left page ─────────────────────────────────────────────── */}
      <path
        d="M1 6 C1 4.3 2.3 3 4 3 L20 3 L20 33 L4 33 C2.3 33 1 31.7 1 30 Z"
        fill="#FDF6E3"
        stroke={color}
        strokeWidth="1.4"
      />

      {/* ── Right page ────────────────────────────────────────────── */}
      <path
        d="M24 3 L40 3 C41.7 3 43 4.3 43 6 L43 30 C43 31.7 41.7 33 40 33 L24 33 Z"
        fill="#FDF6E3"
        stroke={color}
        strokeWidth="1.4"
      />

      {/* ── Spine ─────────────────────────────────────────────────── */}
      <rect x="20" y="3" width="4" height="30" rx="0.5" fill={color} />

      {/* ── Dove (left page) ──────────────────────────────────────── */}
      {/* Body */}
      <ellipse cx="10.5" cy="16" rx="4" ry="2.5" fill={color} opacity="0.75" />
      {/* Head */}
      <circle cx="14" cy="14.5" r="1.6" fill={color} opacity="0.85" />
      {/* Wing */}
      <path
        d="M7 15 C8 11 13 12 14.5 14.5 C12 12.5 8 13.5 7 15Z"
        fill={color}
        opacity="0.9"
      />
      {/* Tail */}
      <path d="M6.5 16 L5 14 L7 15.5 Z" fill={color} opacity="0.75" />

      {/* ── Flame (right page) ────────────────────────────────────── */}
      {/* Outer flame — warm red */}
      <path
        d="M33 30 C30 26 30 21 32.5 18 C31.5 22 34 23 33.5 19.5 C35.5 21 37 25 35 30 Z"
        fill="#E63946"
        opacity="0.9"
      />
      {/* Inner flame — orange */}
      <path
        d="M33 29 C31.5 26 32 23 33.5 21.5 C33 24 34.5 25 34 29 Z"
        fill="#FF9F1C"
      />

      {/* ── Text lines on each page ───────────────────────────────── */}
      <line x1="4"  y1="22" x2="17" y2="22" stroke={color} strokeWidth="0.6" opacity="0.4" />
      <line x1="4"  y1="25" x2="17" y2="25" stroke={color} strokeWidth="0.6" opacity="0.4" />
      <line x1="4"  y1="28" x2="12" y2="28" stroke={color} strokeWidth="0.6" opacity="0.4" />
      <line x1="27" y1="14" x2="40" y2="14" stroke={color} strokeWidth="0.6" opacity="0.4" />
      <line x1="27" y1="17" x2="40" y2="17" stroke={color} strokeWidth="0.6" opacity="0.4" />
    </svg>
  );
}
